import * as React from 'react';
import { IconProps } from '../types';

const IcChevronUp = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M21.5 16c0 .3-.1.5-.3.7-.4.4-1 .4-1.4 0l-7.3-7.3-7.3 7.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l8-8c.4-.4 1-.4 1.4 0l8 8c.2.2.3.4.3.7Z"
    />
  </svg>
);

export default IcChevronUp;